<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Academic Terms</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-term v-if="pagepermission.insertable" @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center"  v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <terms-table :rolesetting="pagepermission" :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
               showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize="meta.per_page"
              :current="meta.current_page"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import TermsTable from '@/components/academicterm/Table'
import AddTerm from '@/components/academicterm/Forms/Add'
export default {
  components: {
    TermsTable,
    AddTerm,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('session', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.getTerms()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 1,
      },

      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  methods: {
    getTerms() {
      this.loading = true
      this.$http.get('/api/lesson-plan/academic-terms', {
        params: {
          per_page: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data
      }).catch(error => {
        this.loading = false
        this.$neoNotify.error(error)
      })
    },
    handleCreated: function() {
      this.getTerms()
    },
    handleUpdateTable: function() {
      this.getTerms()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getTerms()
    },
    onChange(current) {
      this.current = current
      this.getTerms()
    },
  },
}
</script>
